/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_WeightInputs */

const vi_product_classification_weight = /** @type {(inputs: Product_Classification_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng (kg)`)
};

/**

* @param {Product_Classification_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_weight = /** @type {((inputs?: Product_Classification_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_weight(inputs)
});